import { useToastStore } from '@/stores/toast.store';
import type { ToastMessage, ToastAction } from '@/stores/toast.store';

export type { ToastMessage, ToastAction };

/**
 * Toast hook exposing the active toasts plus all action methods,
 * mirroring the Angular Toast service surface (activeToasts + helpers).
 */
export function useToast() {
  const activeToasts = useToastStore((s) => s.toasts);

  const showToast = useToastStore((s) => s.showToast);
  const updateToast = useToastStore((s) => s.updateToast);
  const showRetryToast = useToastStore((s) => s.showRetryToast);
  const showOfflineToast = useToastStore((s) => s.showOfflineToast);
  const showConnectionRestoredToast = useToastStore((s) => s.showConnectionRestoredToast);
  const showErrorWithRetry = useToastStore((s) => s.showErrorWithRetry);
  const showServiceOutageToast = useToastStore((s) => s.showServiceOutageToast);
  const removeToast = useToastStore((s) => s.removeToast);
  const clearAllToasts = useToastStore((s) => s.clearAllToasts);

  return {
    activeToasts,
    showToast,
    updateToast,
    showRetryToast,
    showOfflineToast,
    showConnectionRestoredToast,
    showErrorWithRetry,
    showServiceOutageToast,
    removeToast,
    clearAllToasts,
  };
}
